<div class="loader-overlay">
  <div class="loader-content">
    <div class="logo-wrapper">
      <svg class="logo-svg" viewBox="0 0 80 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="layer layer-1"
          d="M76.9952 40.5938C77.9567 40.5938 78.3642 39.3693 77.5944 38.7932L66.0652 30.1636C65.8923 30.0342 65.682 29.9642 65.466 29.9642H14.534C14.318 29.9642 14.1077 30.0342 13.9348 30.1636L2.4056 38.7932C1.63584 39.3693 2.04333 40.5938 3.00483 40.5938H76.9952Z"
          stroke="#263435" stroke-width="1"/>
        <path class="layer layer-2"
          d="M75.7793 29.9639C76.8276 29.9639 77.1695 28.5561 76.238 28.0753L62.4108 20.9376C62.2689 20.8644 62.1117 20.8262 61.9521 20.8262H18.0485C17.8889 20.8262 17.7317 20.8644 17.5898 20.9376L3.76262 28.0753C2.83115 28.5561 3.17305 29.9639 4.22131 29.9639H75.7793Z"
          stroke="#263435" stroke-width="1"/>
        <path class="layer layer-3"
          d="M74.4287 20.8262C75.536 20.8262 75.8224 19.2934 74.7898 18.8936L58.762 12.6884C58.6468 12.6438 58.5244 12.6209 58.4009 12.6209H21.5998C21.4763 12.6209 21.3539 12.6438 21.2387 12.6884L5.2109 18.8936C4.17828 19.2934 4.46464 20.8262 5.57194 20.8262H74.4287Z"
          stroke="#263435" stroke-width="1"/>
        <path class="layer layer-4"
          d="M72.7103 12.6211C73.8649 12.6211 74.1006 10.9886 72.9932 10.662L55.1176 5.38911C55.0258 5.36201 54.9305 5.34825 54.8347 5.34825H25.1659C25.0702 5.34825 24.9749 5.36201 24.883 5.38911L7.00745 10.662C5.90001 10.9886 6.13576 12.6211 7.29038 12.6211H72.7103Z"
          stroke="#263435" stroke-width="1"/>
        <path class="layer layer-5"
          d="M69.1252 5.34863C70.3335 5.34863 70.5055 3.60384 69.3204 3.36788L55.0138 0.519324C54.9495 0.506521 54.8841 0.500073 54.8185 0.500073H28.649C28.5915 0.500073 28.5341 0.505037 28.4774 0.514912L12.127 3.36347C10.9221 3.57338 11.0756 5.34863 12.2986 5.34863H69.1252Z"
          fill="#104CFE" stroke="#263435" stroke-width="1"/>
      </svg>
    </div>

    <p class="loader-name">SenBac</p>

    <div class="loader-bar">
      <div class="loader-bar-fill"></div>
    </div>
  </div>
</div>
